<button
    mat-stroked-button
    fxLayout="row-reverse"
    fxLayoutAlign="center center"
    mat-stroked-button
    class="white-btn py-8 px-12"
    color="white"
    [class.is-active]="isActive"
    [class.is-rounded]="isRounded"
    [disabled]="disabled"
    [matMenuTriggerFor]="matMenu"
    [loading]="isLoading"
>
    <div fxLayout="row" fxLayoutAlign="flex-start center">
        <mat-icon [class.mr-8]="label || showThreeDots || counter" *ngIf="icon">{{ icon }}</mat-icon>
        <mat-icon [class.mr-8]="label || showThreeDots || counter" *ngIf="svgIcon" [svgIcon]="svgIcon"></mat-icon>

        <span class="text-sm text-nowrap">
            <ng-container *ngIf="counter">{{ counter }}&nbsp;</ng-container>{{ label | translate: labelTranslateParams
            }}<span *ngIf="showThreeDots">...</span>
        </span>
    </div>
    <mat-icon class="ml-8" [svgIcon]="'dropdown_arrow'"></mat-icon>
</button>
